export const PAGE = 'PAGE';

export const STRETCHED = 'STRETCHED';

export const FREE = 'FREE';